<template>
    <div
            class="checkbox-l"
            :class="isError"
    >

        <label class="d-flex">
            <input type="checkbox"
                   name="name"
                   class="checkbox"
                   :disabled="disabled"
                   @change="updateInput">
            <slot></slot>
        </label>

        <Validation v-if="v && v.$dirty" :v="v"/>
    </div>
</template>

<script>
    import Validation from "./Validation";
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
            v: {
                type: Object,
                required: false,
            },
        },
        components: {
            Validation
        },
        methods: {
            updateInput(event) {
                // console.log(event.target.checked, 'event.target.checked')
                this.$emit('input', event.target.checked);
                if (this.v) this.v.$touch();
            }
        },
        computed: {
            isError() {
                let error = ''
                if(this.v && this.v.$error) {
                    error = 'is-error';
                }
                return error
            }
        }
    }
</script>

<style lang="sass" scoped>
    .checkbox-l
        display: flex
        padding: 5px
        margin: 5px auto
        position: relative
        &::v-deep
            .errors
                bottom: auto
                top: 100%
        label
            cursor: pointer
            transition: color .3s ease
        &.is-error
            color: $color--red
            input[type=checkbox]
                border-color: rgba(255, 116, 116, 0.5)
                color: rgba(255, 116, 116, 0.5)
                &:hover
                    background: transparent

    input[type=checkbox],
    input[type=radio],
        label
            user-select: none
    input[type=checkbox],
    input[type=radio]
        cursor: pointer
        position: relative
        border: 1px solid rgba($color--dark, 0.2)
        min-width: 20px
        height: 20px
        background: #fff
        -webkit-appearance: none
        -webkit-border-radius: 2px
        border-radius: 2px
        transition: border-color .2s ease, background .2s ease
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale
        outline: 0
        &:before
            content: ""
            color: white
            font-size: 15px
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
            background: url('~@/assets/images/checkbox/check.svg')
            +cover
            background-size: contain
            width: 12px
            height: 9px
            opacity: 0
            +tr(opacity .1s ease)
        &:focus,
        &:active
            outline: none
        &:hover
            background: #F7F9FF
            border-color: rgba(11, 35, 75, 0.25)
        &:checked
            background: $color--blue
            border-color: transparent
            &:before
                opacity: 1
        &:disabled
            border-color: rgba($color--dark, 0.1)
            cursor: default
            &:hover
                background: none


</style>